export default __webpack_public_path__ + "fast-forward-arrows.png";